<template>
  <div class="map-page">
    <div class="uk-section">
      <iframe
        class="map-page__iframe"
        src="https://www.google.com/maps/d/u/1/embed?mid=1AuGgyVEGdMRqOhoG43um2AO1Mu1c3eIX"
      ></iframe>
      <!-- <div class="uk-container uk-container-large">
        <h1>Map</h1>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "MapPage",
};
</script>
<style lang="css">
.map-page {
  height: 100vh;
  width: 100%;
  position: relative;
}
.map-page__iframe {
  min-width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
